import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'antd';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const EntityAlphaSearch = ({
  entityType, // 'author', 'publisher', 'department', 'category'
  fetchOptions, // async function to fetch options
  onSelect // callback when an option is selected
}) => {
  const [selectedAlpha, setSelectedAlpha] = useState('A');
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // For department, fetch all at once (no alpha)
  useEffect(() => {
    setLoading(true);
    if (entityType === 'department') {
      fetchOptions().then((data) => {
        setOptions(data);
        setFilteredOptions(data);
        setLoading(false);
      });
    } else {
      fetchOptions(selectedAlpha).then((data) => {
        setOptions(data);
        setLoading(false);
      });
    }
  }, [selectedAlpha, fetchOptions, entityType]);

  useEffect(() => {
    if (entityType === 'department') return; // No filtering for department
    if (options && Array.isArray(options)) {
      setFilteredOptions(
        options.filter(opt => {
          const label = opt.label || opt.name || opt.department || opt.title;
          return label && label.toUpperCase().startsWith(selectedAlpha);
        })
      );
    }
  }, [options, selectedAlpha, entityType]);

  return (
    <div>
      {entityType !== 'department' && (
        <div className="d-flex flex-wrap justify-content-center mb-2" style={{gap: 2}}>
          {alphabet.map(ltr => (
            <Button
              key={ltr}
              variant={ltr === selectedAlpha ? 'primary' : 'outline-secondary'}
              className="mx-1 my-1 px-1 py-1 alpha-btn"
              onClick={() => setSelectedAlpha(ltr)}
              style={{ minWidth: 26, fontSize: 13, padding: '3px 7px', borderRadius: 6, height: 30 }}
            >
              {ltr}
            </Button>
          ))}
        </div>
      )}
      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <Row className="g-2">
          {filteredOptions.length === 0 ? (
            <Col className="text-center text-muted small">
              {entityType === 'department' ? 'No departments found' : `No results for ${selectedAlpha}`}
            </Col>
          ) : (
            filteredOptions.map((item, idx) => (
              <Col key={item.id || idx} xs={6} sm={4} md={3} lg={3} className="mb-2 px-1">
                <div
                  className="border rounded bg-white alpha-result-item d-flex align-items-center justify-content-center text-center"
                  style={{ cursor: 'pointer', minHeight: 46, fontSize: 13, padding: 8, borderRadius: 8 }}
                  onClick={() => onSelect(item)}
                >
                  <strong className="w-100" style={{whiteSpace: 'normal', overflowWrap: 'break-word', textOverflow: 'unset'}}>{item.label || item.name || item.department || item.title}</strong>
                </div>
              </Col>
            ))
          )}
        </Row>
      )}
    </div>
  );
};

export default EntityAlphaSearch;
